import { createListener } from '@state/store/createListener';
import { clearResults, performProductSearch, performSearch } from './dealFinderResultsSlice';
import { clearMonthly } from '@state/slices/price-calendar/monthly/priceCalendarMonthlySlice';

/* *************** *
 *   LISTENERS     *
 * *************** */
export const setupDealFinderResultsStateListeners = () => {
  createListener([performProductSearch.pending, performSearch.pending], async (_action, listenerApi) => {
    listenerApi.dispatch(clearResults());
    listenerApi.dispatch(clearMonthly());
  });
};
